/**
 * Dropdown
 */

const dropdownTriggers = document.querySelectorAll('.js-dropdown-trigger');
const searchInput = document.querySelector('.js-search .search__field');

dropdownTriggers.forEach(trigger => {
	trigger.addEventListener('click', function (e) {
		setTimeout(function () {
			searchInput.focus();
		}, 300);

		const currentDropdown = this.closest('.dropdown');

		if (currentDropdown.classList.contains('active')) {
			document.querySelectorAll('.dropdown').forEach(dropdown => {
				dropdown.classList.remove('active');
			})

			currentDropdown.add('active');
		} else {
			document.querySelectorAll('.dropdown').forEach(dropdown => {
				dropdown.classList.remove('active');
			})
		}

		currentDropdown.classList.toggle('active');

		e.preventDefault();
	})
})
